// Copyright 2025. WebPros International GmbH. All rights reserved.

export const moduleMapper = (module: { default: Record<string, unknown> }) => {
    // Make sure that we load proper file.
    if (module?.default && (typeof module.default === 'object')) {
        return module.default;
    }
    throw new Error('Invalid language module');
};
